import { useState } from "react";
import "./restaurant-offers.styles.scss";
import OrderOffers from "./orderOffers/orderOffers.component";
import MenuOffers from "./menuOffers/menuOffers.component";
const RestaurantOffers = () => {
  const [orderOffersClass, setOrdersOffersClass] = useState(
    "restaurant-offers-left-option active"
  );
  const [menuOffersClass, setMenuOffersClass] = useState(
    "restaurant-offers-left-option"
  );
  const [currentPane, setCurrentPane] = useState("order");
  const changePane = (pane) => {
    setCurrentPane(pane);
    if (pane === "order") {
      setOrdersOffersClass("restaurant-offers-left-option active");
      setMenuOffersClass("restaurant-offers-left-option");
    } else if (pane === "menu") {
      setOrdersOffersClass("restaurant-offers-left-option");
      setMenuOffersClass("restaurant-offers-left-option active");
    }
  };
  return (
    <div className="restaurant-offers-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-offers-desktop">
          <div className="restaurant-offers-left">
            <div className="restaurant-offers-left-title-container">
              <span className="restaurant-offers-left-title">
                Choose from below options
              </span>
            </div>
            <div className="restaurant-offers-left-options">
              <span
                className={orderOffersClass}
                onClick={() => changePane("order")}
              >
                <span>Order offers</span>
                <span>{">"}</span>
              </span>
              <span
                className={menuOffersClass}
                onClick={() => changePane("menu")}
              >
                <span>Menu offers</span>
                <span>{">"}</span>
              </span>
            </div>
          </div>
          <div className="restaurant-offers-right">
            {currentPane === "order" ? <OrderOffers /> : <MenuOffers />}
          </div>
        </div>
      ) : (
        <div className="restaurant-offers-mobile">
          <div className="restaurant-offers-left">
            <div className="restaurant-offers-left-title-container">
              <span className="restaurant-offers-left-title">
                Choose from below options
              </span>
            </div>
            <div className="restaurant-offers-left-options">
              <span
                className={orderOffersClass}
                onClick={() => changePane("order")}
              >
                <span>Order offers</span>
              </span>
              <span
                className={menuOffersClass}
                onClick={() => changePane("menu")}
              >
                <span>Menu offers</span>
              </span>
            </div>
          </div>
          <div className="restaurant-offers-right">
            {currentPane === "order" ? <OrderOffers /> : <MenuOffers />}
          </div>
        </div>
      )}
    </div>
  );
};
export default RestaurantOffers;
